import { __module as t } from "./ghl-ui.es1705.js";
import { i as l } from "./ghl-ui.es1541.js";
import { t as x } from "./ghl-ui.es1631.js";
import { s as _ } from "./ghl-ui.es1706.js";
import { s as v } from "./ghl-ui.es1707.js";
import { r as E } from "./ghl-ui.es1637.js";
(function(o, r) {
  var e = l.default;
  Object.defineProperty(r, "__esModule", {
    value: !0
  }), r.default = p;
  var f = e(x), i = e(_), s = e(v), u = e(E), d = 6048e5;
  function p(m) {
    (0, u.default)(1, arguments);
    var a = (0, f.default)(m), n = (0, i.default)(a).getTime() - (0, s.default)(a).getTime();
    return Math.round(n / d) + 1;
  }
  o.exports = r.default;
})(t, t.exports);
var W = t.exports;
export {
  W as g
};
